import React from 'react';

import { Painel } from '../../../../components/Painel';
import { Icon } from '../../../../components/Icon';
import { colors } from '../../../../styles/tokens';

import { Container, IconBox, Text, Title } from './styles';

interface ComingSoonProps {
  title: string;
}

const ComingSoon: React.FC<ComingSoonProps> = ({ title }) => {
  return (
    <Painel>
      <Container>
        <IconBox>
          <Icon name="construction" size={28} color={colors.primary} />
        </IconBox>
        <Title>{title}</Title>
        <Text>
          Esta tela ainda será criada. Em breve essa funcionalidade estará
          disponível.
        </Text>
      </Container>
    </Painel>
  );
};

export { ComingSoon };
